import { BiteLogFreedomPayEvent } from './bite_log_freedom_pay_event.js';

export function name(event: BiteLogFreedomPayEvent): string {
  switch (event) {
    case BiteLogFreedomPayEvent.None:
      return 'ok';
    case BiteLogFreedomPayEvent.Payment:
      return 'payment-success';
    case BiteLogFreedomPayEvent.PaymentError:
      return 'payment-error';
    case BiteLogFreedomPayEvent.Refund:
      return 'refund-success';
    case BiteLogFreedomPayEvent.RefundError:
      return 'refund-error';
    case BiteLogFreedomPayEvent.ReverseRefund:
      return 'reverse-refund-attempt';
    case BiteLogFreedomPayEvent.TokenizationError:
      return 'tokenization-error';
    case BiteLogFreedomPayEvent.IframeInitError:
      return 'iframe-init-error';
    case BiteLogFreedomPayEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogFreedomPayEvent.UpdateIdleTextError:
      return 'update-idle-text-error';
    case BiteLogFreedomPayEvent.AuthTransaction:
      return 'auth-transaction';
    case BiteLogFreedomPayEvent.AuthTransactionError:
      return 'auth-transaction-error';
    case BiteLogFreedomPayEvent.SaleTransaction:
      return 'sale-transaction';
    case BiteLogFreedomPayEvent.SaleTransactionError:
      return 'sale-transaction-error';
    case BiteLogFreedomPayEvent.Logs:
      return 'logs';
    case BiteLogFreedomPayEvent.InstallPal:
      return 'install-pal';
    case BiteLogFreedomPayEvent.InstallPalError:
      return 'install-pal-error';
    case BiteLogFreedomPayEvent.TerminalConnected:
      return 'terminal-connected';
    case BiteLogFreedomPayEvent.PerformMaintenance:
      return 'perform-maintenance';
    case BiteLogFreedomPayEvent.NativeTransaction:
      return 'native-transaction';
    case BiteLogFreedomPayEvent.NativeTransactionError:
      return 'native-transaction-error';
    case BiteLogFreedomPayEvent.ReplayTransaction:
      return 'replay-transaction';
    case BiteLogFreedomPayEvent.ReplayTransactionError:
      return 'replay-transaction-error';
    case BiteLogFreedomPayEvent.CommandSync:
      return 'command-sync';
  }
}
